module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
var pageItems = ['_self', '_blank'];
var pageItemsText=['Current browser window','New browser window']

    ; __append("\r\n\r\n\r\n<div class=\"prop-header\"><span class=\"prop-label\">Target</span></div>\r\n<div class=\"prop-detail row\">\r\n    <div class=\"col-md-12\" style=\"padding-right:0px;\">\r\n        <select id=\"target\" name=\"target\" class=\"\">\r\n            ")
    ;  for (var i = 0; i < pageItems.length; i++) { 
    ; __append("\r\n                <option value=\"")
    ; __append(escapeFn( pageItems[i] ))
    ; __append("\">")
    ; __append(escapeFn( pageItemsText[i] ))
    ; __append("</option>\r\n            ")
    ;  }; 
    ; __append("\r\n        </select>\r\n    </div>\r\n</div>")
  }
  return __output;

}